import { Switch, SwitchProps } from '@ui/lib/park/ui/switch';
import { useTranslation } from 'next-i18next';

export const ViewExecutedOnly = (p: SwitchProps) => {
  const { t } = useTranslation();

  return (
    <Switch textStyle="v2.meta" color="v2.text.muted" {...p}>
      {t('common.View Executed Only')}
    </Switch>
  );
};
